import { round } from 'lodash'


export const OutputTorqueNotExceeded = {
    name: "OutputTorque",
    run: (fact, emit) => {

        const reduction = fact.stages.reduce((acc, stage) => acc * stage.reduction, 1)
        const inputTorque = round(fact.input?fact.input.inputTorque:0,2)
        const outputTorque = round(inputTorque * reduction,2)
        const maxTorque = round(fact.output?fact.output.maxTorque:Infinity, 2)
        if(outputTorque > maxTorque) {
            emit(`You are producing ${outputTorque} N-m which is more than the suggested amount for the ${fact.output?fact.output.name:"chosen"} output stage of ${fact.output?fact.output.maxTorque:"Unknown"} N-m.`)
        }
    }
  }



